import React, { Component } from "react"
import { Link } from "gatsby"
import t from "../../../locale"

import bread1 from "../../images/bread1.jpg"
import pastries1 from "../../images/pastries1.jpg"
import articMain from "../../images/articMain.jpg"
import baker1 from "../../images/baker1.jpg"
import testEntrance from "../../images/testEntrance.jpg"

import "./BakeryGallery.scss"

let gridContent = [];

if (typeof t === "function") {
  gridContent = [
    {
      img: bread1,
      content: t("bakeryGridBreadContent"),
      header: t("navLink3"),
      buttonText: "Find More",
      path: "/bread",
    },
    {
      img: pastries1,
      content: t("bakeryGridPastriesContent"),
      header: t("navLink4"),
      buttonText: "Find More",
      path: "/pastries",
    },
    {
      img: articMain,
      content: t("bakeryGridShopContent"),
      header: t("navLink5"),
      buttonText: "Find More",
      path: "/shop",
    },
    {
      img: baker1,
      content: t("bakeryGridOurStoryContent"),
      header: t("navLink2"),
      buttonText: "Find More",
      path: "/ourStory",
    },
    {
      img: testEntrance,
      content: t("bakeryGridContactContent"),
      header: t("navLink6"),
      buttonText: "Find Us",
      path: "/contact",
    },
  ]
}

class BakeryGallery extends Component {

  // TODO: render hover
  renderGridItem = () => {

    if (typeof t === "function") {
      return gridContent.map((item, i) => {
        let className = `grid-item item-${i}`

        return (
          <div key={i} className={className}>
            <div className="grid-item-inner">
              <h4 className="grid-item-inner-header">{item.header}</h4>
              <p className="grid-item-inner-desc">{item.content}</p>
              <Link to={item.path}>
                <button className="grid-item-inner-button">{item.buttonText}</button>
              </Link>
            </div>
          </div>
        )

      })
    }
  }

  render() {

    return (
      this.renderGridItem()
    )
  }
}

export default BakeryGallery